import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

/* A 2px accent line across the top, filling as the page is read. */
export function ScrollProgress({ className = 'ds-progress' }: { className?: string }) {
    const { scrollYProgress } = useScroll();
    const width = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
    return <motion.div className={className} style={{ scaleX: width }} />;
}
